module.exports = __webpack_public_path__ + "img/sup_kyc_4.5c16c974.jpg";